import { createStore } from 'vuex';

export default createStore({
  state: {
    user: "",
    assessor: ""
  },
  getters: {
  },
  mutations: {
    connect(state, data) {
      window.localStorage['user'] = JSON.stringify(data);
      state.user = data;
    },
    disconnect(state) {
      state.user = '';
      window.localStorage.removeItem('user');
    }
  },
  actions: {
  },
  modules: {
  },
});
